export const demoTrips = [
  {
    id: 'demo-andorra-spain',
    slug: 'andorra-spain-2026',
    name: 'Andorra + Spain',
    color: '#f97316',
    status: 'active',
    start_date: '2026-07-28',
    end_date: '2026-08-03',
    leave_days: 4,
    countries_count: 2,
    summary: 'Coma Pedrosa and Mulhacén with Barcelona–Málaga positioning.',
  },
  {
    id: 'demo-portugal',
    slug: 'mount-pico',
    name: 'Portugal — Mount Pico',
    color: '#38bdf8',
    status: 'planned',
    start_date: null,
    end_date: null,
    leave_days: null,
    countries_count: 1,
    summary: 'Standalone Azores trip built around Mount Pico.',
  },
  {
    id: 'demo-lapland',
    slug: 'lapland-loop',
    name: 'Lapland Loop',
    color: '#a78bfa',
    status: 'planned',
    start_date: null,
    end_date: null,
    leave_days: 4,
    countries_count: 2,
    summary: 'Kebnekaise and Saana Fell, returning through Tromsø.',
  },
  {
    id: 'demo-romania-moldova',
    slug: 'romania-moldova',
    name: 'Romania + Moldova',
    color: '#22c55e',
    status: 'future',
    start_date: null,
    end_date: null,
    leave_days: null,
    countries_count: 2,
    summary: 'Moldoveanu plus Bălănești Hill after the September exam window.',
  },
  {
    id: 'demo-balkans-a',
    slug: 'balkans-a',
    name: 'Balkans A',
    color: '#e879f9',
    status: 'future',
    start_date: null,
    end_date: null,
    leave_days: null,
    countries_count: 3,
    summary: 'Croatia, Bosnia and Montenegro.',
  },
]

export const demoSummits = [
  {
    id: 'summit-andorra',
    trip_id: 'demo-andorra-spain',
    country_code: 'AD',
    country_name: 'Andorra',
    flag: '🇦🇩',
    peak_name: 'Coma Pedrosa',
    elevation_m: 2942,
    latitude: 42.591,
    longitude: 1.444,
    status: 'planned',
    summit_date: '2026-07-30',
    scenic_choice: false,
    difficulty: 'Mountain hike',
    route_notes: 'Approach from Arinsal. Will is joining at minimum for this leg.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-spain',
    trip_id: 'demo-andorra-spain',
    country_code: 'ES',
    country_name: 'Spain',
    flag: '🇪🇸',
    peak_name: 'Mulhacén',
    elevation_m: 3479,
    latitude: 37.0548,
    longitude: -3.311,
    status: 'planned',
    summit_date: '2026-08-01',
    scenic_choice: false,
    difficulty: 'High mountain hike',
    route_notes: 'Capileira park shuttle route. Sunday retained as the weather spare.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-portugal',
    trip_id: 'demo-portugal',
    country_code: 'PT',
    country_name: 'Portugal',
    flag: '🇵🇹',
    peak_name: 'Mount Pico',
    elevation_m: 2351,
    latitude: 38.468,
    longitude: -28.399,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Volcanic mountain hike',
    route_notes: 'Standalone Azores trip rather than forcing it into an Iberian loop.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-sweden',
    trip_id: 'demo-lapland',
    country_code: 'SE',
    country_name: 'Sweden',
    flag: '🇸🇪',
    peak_name: 'Kebnekaise / Sydtoppen',
    elevation_m: 2097,
    latitude: 67.9006,
    longitude: 18.5164,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Long mountain day',
    route_notes: 'Western route. Second or third week of August preferred.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-finland',
    trip_id: 'demo-lapland',
    country_code: 'FI',
    country_name: 'Finland',
    flag: '🇫🇮',
    peak_name: 'Saana Fell',
    elevation_m: 1029,
    latitude: 69.043,
    longitude: 20.858,
    status: 'future',
    summit_date: null,
    scenic_choice: true,
    difficulty: 'Hike',
    route_notes: 'Chosen for the experience and views rather than the technical high point.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-romania',
    trip_id: 'demo-romania-moldova',
    country_code: 'RO',
    country_name: 'Romania',
    flag: '🇷🇴',
    peak_name: 'Moldoveanu',
    elevation_m: 2544,
    latitude: 45.599,
    longitude: 24.736,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Mountain hike',
    route_notes: 'Bâlea Cascadă cable-car plan with an on-the-day weather decision.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-moldova',
    trip_id: 'demo-romania-moldova',
    country_code: 'MD',
    country_name: 'Moldova',
    flag: '🇲🇩',
    peak_name: 'Bălănești Hill',
    elevation_m: 429,
    latitude: 47.21,
    longitude: 28.087,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Walk',
    route_notes: 'Marshrutka plus local taxi.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-croatia',
    trip_id: 'demo-balkans-a',
    country_code: 'HR',
    country_name: 'Croatia',
    flag: '🇭🇷',
    peak_name: 'Dinara / Sinjal',
    elevation_m: 1831,
    latitude: 44.063,
    longitude: 16.382,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Mountain hike',
    route_notes: '',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-bosnia',
    trip_id: 'demo-balkans-a',
    country_code: 'BA',
    country_name: 'Bosnia & Herzegovina',
    flag: '🇧🇦',
    peak_name: 'Maglić',
    elevation_m: 2386,
    latitude: 43.281,
    longitude: 18.733,
    status: 'future',
    summit_date: null,
    scenic_choice: false,
    difficulty: 'Exposed scramble',
    route_notes: 'Upper section includes Class 3 terrain and fixed cables; verify comfort and equipment.',
    hero_image_url: '',
    reel_url: '',
  },
  {
    id: 'summit-montenegro',
    trip_id: 'demo-balkans-a',
    country_code: 'ME',
    country_name: 'Montenegro',
    flag: '🇲🇪',
    peak_name: 'Bobotov Kuk',
    elevation_m: 2523,
    latitude: 43.127,
    longitude: 19.036,
    status: 'future',
    summit_date: null,
    scenic_choice: true,
    difficulty: 'Mountain hike / scramble',
    route_notes: 'Zla Kolata remains worth revisiting when the Balkan clustering is finalised.',
    hero_image_url: '',
    reel_url: '',
  },
]

export const demoRoutePoints = [
  { id: 'route-1', trip_id: 'demo-andorra-spain', position: 1, label: 'Leeds Bradford', kind: 'airport', latitude: 53.8659, longitude: -1.6606 },
  { id: 'route-2', trip_id: 'demo-andorra-spain', position: 2, label: 'Barcelona', kind: 'airport', latitude: 41.2974, longitude: 2.0833 },
  { id: 'route-3', trip_id: 'demo-andorra-spain', position: 3, label: 'Arinsal', kind: 'base', latitude: 42.572, longitude: 1.484 },
  { id: 'route-4', trip_id: 'demo-andorra-spain', position: 4, label: 'Coma Pedrosa', kind: 'summit', latitude: 42.591, longitude: 1.444 },
  { id: 'route-5', trip_id: 'demo-andorra-spain', position: 5, label: 'Barcelona', kind: 'airport', latitude: 41.2974, longitude: 2.0833 },
  { id: 'route-6', trip_id: 'demo-andorra-spain', position: 6, label: 'Málaga', kind: 'airport', latitude: 36.6749, longitude: -4.4991 },
  { id: 'route-7', trip_id: 'demo-andorra-spain', position: 7, label: 'Capileira', kind: 'base', latitude: 36.961, longitude: -3.358 },
  { id: 'route-8', trip_id: 'demo-andorra-spain', position: 8, label: 'Mulhacén', kind: 'summit', latitude: 37.0548, longitude: -3.311 },
  { id: 'route-9', trip_id: 'demo-andorra-spain', position: 9, label: 'Manchester', kind: 'airport', latitude: 53.3537, longitude: -2.275 },

  { id: 'route-10', trip_id: 'demo-lapland', position: 1, label: 'Tromsø', kind: 'airport', latitude: 69.6492, longitude: 18.9553 },
  { id: 'route-11', trip_id: 'demo-lapland', position: 2, label: 'Kebnekaise', kind: 'summit', latitude: 67.9006, longitude: 18.5164 },
  { id: 'route-12', trip_id: 'demo-lapland', position: 3, label: 'Saana Fell', kind: 'summit', latitude: 69.043, longitude: 20.858 },
  { id: 'route-13', trip_id: 'demo-lapland', position: 4, label: 'Tromsø', kind: 'airport', latitude: 69.6492, longitude: 18.9553 },
]

export const demoRouteLegs = []

export const demoData = {
  trips: demoTrips,
  summits: demoSummits,
  routePoints: demoRoutePoints,
  routeLegs: demoRouteLegs,
  photos: [],
}
